import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePropertyModel, DateRange, toHttpParams } from 'hx-services';

export type CopyPropertiesOperation = 'APPLY_ALL' | 'APPLY_ALL_EXCEPT_EXIST';

export interface CopyPropertiesRequest {
  sourceStoreId: number;
  targetStoreId: number;
  dateRange: DateRange;
  operation: CopyPropertiesOperation;
}

@Injectable({
  providedIn: 'root'
})
export class VanillaService {

  constructor(
    private httpService: HttpClient,
  ) {
  }

  getProperties(params: {
    date?: DateRange,
    storeId?: number,
    month?: boolean
  }): Observable<DatePropertyModel[]> {
    return this.httpService.get<DatePropertyModel[]>(`/api/vn/property`, {params: toHttpParams(params, true)});
  }

  postProperty(body: any): Observable<any> {
    return this.httpService.post(`/api/vn/property/check`, body);
  }

  confirmProperties(body: any): Observable<any> {
    return this.httpService.post(`/api/vn/property/confirm`, body);
  }

  updateProperty(propertyId: number, body: any): Observable<any> {
    return this.httpService.post(`/api/vn/property/${propertyId}/update/check`, body);
  }

  confirmUpdateProperty(propertyId: number, body: any): Observable<any> {
    return this.httpService.put(`/api/vn/property/${propertyId}/confirm`, body);
  }

  getProperty(propertyId: number): Observable<DatePropertyModel> {
    return this.httpService.get<DatePropertyModel>(`/api/vn/property/${propertyId}`);
  }

  updateDecor(id: number, body: any): Observable<any> {
    return this.httpService.put(`/api/vn/property/decor/${id}`, body);
  }

  updateOnlineSellable(id: number, body: any): Observable<any> {
    return this.httpService.put(`/api/vn/property/online-sellable/${id}`, body);
  }

  copyProperties(body: CopyPropertiesRequest): Observable<unknown[]> {
    return this.httpService.post<unknown[]>(`/api/vn/property/copy`, body);
  }
}
